export const HOTSPOT_WIDGET_REQUEST = [
  {
    "name": "Hotspot",
    "type": "cleverstory.v2.widgets.hotspot",
    "properties": {
      "desktop": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "-198px,-37.5px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "176px",
          "height": "152.39999999999998px",
          "minWidth": "153px",
          "minHeight": "119px"
        },
        "shadow": {
          "color": {
            "r": 255,
            "g": 255,
            "b": 255,
            "a": 1
          },
          "axes": {
            "x": 0,
            "y": 0,
            "b": 0
          },
          "show": false
        }
      },
      "mobile": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "280px,0px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "shadow": {
            "color": {
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            },
            "axes": {
              "x": 0,
              "y": 0,
              "b": 0
            },
            "show": false
          },
          "width": "163px",
          "height": "121px",
          "minWidth": "163px",
          "minHeight": "121px"
        }
      }
    },
    "order": 1
  },
  {
    "type": "cleverstory.v2.widgets.text",
    "name": "Text",
    "properties": {
      "desktop": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "14.1391px,18px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "auto",
          "height": "auto",
          "minWidth": "10px",
          "minHeight": "10px"
        },
        "fontSize": 16,
        "lineSpacing": "1.2",
        "letterSpacing": "0",
        "alignment": "left"
      },
      "mobile": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "0px, 0px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "76px",
          "height": "auto",
          "minWidth": "10px",
          "minHeight": "10px"
        },
        "fontSize": 13,
        "lineSpacing": "1.2",
        "letterSpacing": "0",
        "alignment": "left"
      }
    },
    "content": "<h1 style=\"font-size: 16px;\"><span style=\"font-size: 16px; font-weight: bold;\">Example 1</span></h1>",
    "order": 1,
    "fonts": [],
    "actions": []
  },
  {
    "type": "cleverstory.v2.widgets.text",
    "name": "Text",
    "properties": {
      "desktop": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "14px,45px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "auto",
          "height": "auto",
          "minWidth": "10px",
          "minHeight": "10px"
        },
        "fontSize": 16,
        "lineSpacing": "1.2",
        "letterSpacing": "0",
        "alignment": "left"
      },
      "mobile": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "0px, 27.5px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "163px",
          "height": "auto",
          "minWidth": "10px",
          "minHeight": "10px"
        },
        "fontSize": 16,
        "lineSpacing": "1.2",
        "letterSpacing": "0",
        "alignment": "left"
      }
    },
    "content": "<p style=\"font-size: 16px;\">lorom ipsum dolor</p>\n<p>sit amet conse</p>",
    "order": 2,
    "fonts": [],
    "actions": [],
  },
  {
    "type": "cleverstory.v2.widgets.text",
    "name": "Text",
    "properties": {
      "desktop": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "14px,91.6953125px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "auto",
          "height": "auto",
          "minWidth": "10px",
          "minHeight": "10px"
        },
        "fontSize": 18,
        "lineSpacing": "1.2",
        "letterSpacing": "0",
        "alignment": "left"
      },
      "mobile": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "0.5px, 73.90615px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "44px",
          "height": "auto",
          "minWidth": "10px",
          "minHeight": "10px"
        },
        "fontSize": 13,
        "lineSpacing": "1.2",
        "letterSpacing": "0",
        "alignment": "left"
      }
    },
    "content": "<p style=\"font-size: 18px;\"><span style=\"color: rgb(248, 231, 28);\">$889.9</span></p>",
    "order": 3,
    "fonts": [],
    "actions": []
  },
  {
    "type": "cleverstory.v2.widgets.text",
    "name": "Text",
    "properties": {
      "desktop": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "14.039px,122.09375px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "auto",
          "height": "auto",
          "minWidth": "10px",
          "minHeight": "10px"
        },
        "fontSize": 12,
        "lineSpacing": "1.2",
        "letterSpacing": "0",
        "alignment": "left"
      },
      "mobile": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "1.5px, 104.9062px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "43.5px",
          "height": "auto",
          "minWidth": "10px",
          "minHeight": "10px"
        },
        "fontSize": 13,
        "lineSpacing": "1.2",
        "letterSpacing": "0",
        "alignment": "left"
      }
    },
    "content": "<p style=\"font-size: 12px;\"><span style=\"font-size: 12px;\">more</span></p>",
    "order": 4,
    "fonts": [],
    "actions": []
  }
]